/**
 * 日期显示组件
 * 显示公历日期、星期和农历
 */
<template>
  <div class="date-card">
    <div class="date-icon">
      <i class="el-icon-date"></i>
    </div>
    <div class="date-content">
      <span class="date-solar">{{ solarDate }}</span>
      <span class="date-divider">|</span>
      <span class="date-lunar">{{ lunarDate }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateCard',
  data() {
    return {
      now: new Date()
    };
  },
  computed: {
    solarDate() {
      const year = this.now.getFullYear();
      const month = this.now.getMonth() + 1;
      const day = this.now.getDate();
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const weekDay = weekDays[this.now.getDay()];
      return `${year}年${month}月${day}日 ${weekDay}`;
    },
    lunarDate() {
      return this.getLunarDate(this.now);
    }
  },
  mounted() {
    // 每分钟更新一次日期
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 60000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getLunarDate(date) {
      const lunarInfo = [
        0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2,
        0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977,
        0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970,
        0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
        0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557,
        0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5d0, 0x14573, 0x052d0, 0x0a9a8, 0x0e950, 0x06aa0,
        0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0,
        0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b5a0, 0x195a6,
        0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570,
        0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0,
        0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5,
        0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
        0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530,
        0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45,
        0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0
      ];
      
      const Gan = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
      const Zhi = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
      const Animals = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];
      const lunarMonths = ['正', '二', '三', '四', '五', '六', '七', '八', '九', '十', '冬', '腊'];
      const lunarDays = ['初一', '初二', '初三', '初四', '初五', '初六', '初七', '初八', '初九', '初十',
        '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十',
        '廿一', '廿二', '廿三', '廿四', '廿五', '廿六', '廿七', '廿八', '廿九', '三十'];

      const lYearDays = (y) => {
        let sum = 348;
        for (let i = 0x8000; i > 0x8; i >>= 1) {
          sum += (lunarInfo[y - 1900] & i) ? 1 : 0;
        }
        return sum + this.leapDays(y, lunarInfo);
      };

      this.leapDays = (y, info) => {
        if (this.leapMonth(y, info)) {
          return (info[y - 1900] & 0x10000) ? 30 : 29;
        }
        return 0;
      };

      this.leapMonth = (y, info) => {
        return info[y - 1900] & 0xf;
      };

      const monthDays = (y, m, info) => {
        return (info[y - 1900] & (0x10000 >> m)) ? 30 : 29;
      };

      let offset = Math.floor((date - new Date(1900, 0, 31)) / 86400000);
      let year = 1900;
      let temp = 0;

      for (year = 1900; year < 2100 && offset > 0; year++) {
        temp = lYearDays(year);
        offset -= temp;
      }
      if (offset < 0) {
        offset += temp;
        year--;
      }

      const leap = this.leapMonth(year, lunarInfo);
      let isLeap = false;
      let month = 1;

      for (month = 1; month < 13 && offset > 0; month++) {
        if (leap > 0 && month === (leap + 1) && !isLeap) {
          --month;
          isLeap = true;
          temp = this.leapDays(year, lunarInfo);
        } else {
          temp = monthDays(year, month, lunarInfo);
        }
        if (isLeap && month === (leap + 1)) isLeap = false;
        offset -= temp;
      }

      if (offset === 0 && leap > 0 && month === leap + 1) {
        if (isLeap) {
          isLeap = false;
        } else {
          isLeap = true;
          --month;
        }
      }
      if (offset < 0) {
        offset += temp;
        --month;
      }

      const day = offset + 1;
      const ganIndex = (year - 4) % 10;
      const zhiIndex = (year - 4) % 12;
      const animal = Animals[zhiIndex];

      return `农历${lunarMonths[month - 1]}月${lunarDays[day - 1]} ${Gan[ganIndex]}${Zhi[zhiIndex]}年【${animal}】`;
    }
  }
};
</script>

<style lang="less" scoped>
.date-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  background: #f5f7fa;
  border-radius: 12px;

  .date-icon {
    width: 36px;
    height: 36px;
    background: rgba(43, 119, 255, 0.1);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 18px;
      color: #2B77FF;
    }
  }

  .date-content {
    display: flex;
    align-items: center;
    gap: 8px;

    .date-solar {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
    }

    .date-divider {
      color: #dcdfe6;
      font-weight: 300;
    }

    .date-lunar {
      font-size: 13px;
      color: #909399;
    }
  }
}
</style>
